export default function Checklist ({className}) {
  return (
    <svg id="Checklist" xmlns="http://www.w3.org/2000/svg" width="24.729" height="24" viewBox="0 0 24.729 24" class={`MuiSvgIcon-root ${className}`}>
      <circle id="Ellipse_705" data-name="Ellipse 705" cx="12" cy="12" r="12" transform="translate(0.729)" fill="#8fe685"/>
      <g id="done_black_24dp">
        <path id="Tracé_13972" data-name="Tracé 13972" d="M0,0H24V24H0Z" fill="none"/>
        <path id="Tracé_13973" data-name="Tracé 13973" d="M9,16.2,5.5,12.7a.99.99,0,1,0-1.4,1.4l4.19,4.19a1,1,0,0,0,1.41,0L20.3,7.7a.99.99,0,0,0-1.4-1.4Z" fill="#fff"/>
      </g>
    </svg>
  )
}


